import React from "react";
import { useLocation, Navigate } from "react-router-dom";

const MobileRedirect = ({ to }: { to: string }) => {
  const location = useLocation();
  const [pathname, targetHash] = to.split("#");
  const redirectPath = `${pathname}${location.search}${targetHash ? `#${targetHash}` : location.hash}`;
  return <Navigate to={redirectPath} replace />;
};

export default MobileRedirect;
